import React from 'react';
import TablaOperaciones from '../../components/tables/Operaciones';

const Operaciones = () => {
    return (
        <TablaOperaciones/>
    );
}
 
export default Operaciones;